import { absolutePath } from "./absolutePath";

interface CommunityMemberSubscriptionPriceChangesFnProps {
  params?: Record<string, unknown>;
  subscriptionId?: string | number;
}

export const communityMemberSubscriptionPriceChanges = {
  preview: ({
    subscriptionId,
    params = {},
  }: CommunityMemberSubscriptionPriceChangesFnProps = {}) =>
    absolutePath(
      `community_member_subscriptions/${subscriptionId}/price_changes/preview`,
      params,
    ),
  create: ({
    subscriptionId,
    params = {},
  }: CommunityMemberSubscriptionPriceChangesFnProps = {}) =>
    absolutePath(
      `community_member_subscriptions/${subscriptionId}/price_changes`,
      params,
    ),
};
